export default __webpack_public_path__ + "static/media/hands.39d751cd.png";